class ProductSwitcher extends HTMLElement {
  constructor() {
    super();
    this._loading = false;
  }

  connectedCallback() {
    this._handleClick = this._handleClick.bind(this);
    this.addEventListener('click', this._handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._handleClick);
  }

  async _handleClick(event) {
    const button = event.target.closest('.product-switcher-btn');
    if (!button || button.classList.contains('is-active') || this._loading) return;

    const productUrl = button.dataset.productUrl;
    const sectionId = this.dataset.sectionId;
    const sectionWrapper = document.getElementById(`shopify-section-${sectionId}`);
    if (!sectionWrapper) return;

    this._loading = true;
    sectionWrapper.classList.add('product-switcher--loading');

    try {
      const response = await fetch(`${productUrl}?sections=${sectionId}`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      const html = data[sectionId];
      if (!html) throw new Error(`Section "${sectionId}" not found in response`);

      // The Section Rendering API returns the full wrapper div including
      // #shopify-section-{id}, so parse it and extract the inner content.
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newWrapper = doc.getElementById(`shopify-section-${sectionId}`);
      sectionWrapper.innerHTML = newWrapper ? newWrapper.innerHTML : html;
      sectionWrapper.classList.remove('product-switcher--loading');

      // Update the browser URL to match the switched product
      window.history.pushState({}, '', productUrl);

      // Reinitialize Shopify dynamic checkout buttons if present
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }

      // Reinitialize Yotpo widgets for the new product
      if (window.yotpoWidgetsContainer) {
        window.yotpoWidgetsContainer.initWidgets();
      } else if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
        window.yotpo.refreshWidgets();
      }

      // this element is now disconnected; the new <product-switcher> takes over.
    } catch (error) {
      console.error('[ProductSwitcher]', error);
      this._loading = false;
      sectionWrapper.classList.remove('product-switcher--loading');
    }
  }
}

customElements.define('product-switcher', ProductSwitcher);
